import { mask } from './mask'

export const dateMask = mask('**/**/****')
export const timeMask = mask('**:**')
export const phoneMask = mask('(**) * ****-****')
export const justNumbers = (value: string) => String(value).replace(/\D/gi, '')
